import { offsetElement } from '../../../resources/scripts/components/c-focus';
import { initVideoControls } from '../../../resources/scripts/components/video-controls';

const activeNavItemClass = 'hero-home__nav-item--active';
const activeMediaClass = 'hero-home__media--active';
const inactiveDefaultMediaClass = 'hero-home__media-default--hide';

function initHeroHome(root) {
  const items = root.querySelectorAll('[data-hero-home-nav-item]');
  const navLinks = root.querySelectorAll('.hero-home__nav-content');
  const defaultMedia = root.querySelector('[data-hero-home-media-default]');
  let activeItem = null;

  function toggleLink(targetElement) {
    const currentItem = targetElement.dataset.heroHomeNavItem;

    if (activeItem !== currentItem) {
      const activeNavItem = root.querySelector(`.${activeNavItemClass}`);

      if (activeNavItem) {
        activeNavItem.classList.remove(activeNavItemClass);
      }
      targetElement.classList.add(activeNavItemClass);

      const activeMedia = root.querySelector(`.${activeMediaClass}`);
      if (activeMedia) {
        activeMedia.classList.remove(activeMediaClass);
      }
      const currentMedia = root.querySelector(`[data-hero-home-nav-item='${currentItem}']`);
      if (currentMedia) {
        currentMedia.classList.add(activeMediaClass);
      }

      activeItem = currentItem;
      defaultMedia.classList.add(inactiveDefaultMediaClass);
    } else if (!activeItem) {
      targetElement.classList.add(activeNavItemClass);
      const currentMedia = root.querySelector(`[data-hero-home-nav-item=${currentItem}]`);
      if (currentMedia) {
        currentMedia.classList.add(activeMediaClass);
      }

      activeItem = currentItem;
      defaultMedia.classList.add(inactiveDefaultMediaClass);
    }
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', (e) => {
      const targetElement = e.target;

      toggleLink(targetElement);
    });
  });

  navLinks.forEach((link) => {
    link.addEventListener('focus', (e) => {
      const targetElement = e.target.closest('.hero-home__nav-item');

      toggleLink(targetElement);

      const heroNav = root.querySelector('.hero-home__nav');
      const activeHeroNav = heroNav.querySelector(`.${activeNavItemClass}`);

      let offset = 0;

      if (activeHeroNav) {
        offset = 20;
      }

      offsetElement(targetElement, offset);
    });
  });
}

document.querySelectorAll('.hero-home').forEach(initHeroHome);

// Swap hero video poster to desktop size on viewports wider than 768px.
// The HTML poster defaults to the mobile size (768×432) to minimise data use.
// On desktop we upgrade to the full-resolution poster for better quality.
const heroDesktopMq = window.matchMedia('(min-width: 768px)');

function swapHeroPosters(mq) {
  document.querySelectorAll('[data-poster-desktop]').forEach((video) => {
    if (mq.matches) {
      const media = video;
      media.poster = media.dataset.posterDesktop;

      // <video-js> is an inert custom element until video.js initializes it, so the
      // poster is also painted via a plain CSS background-image (see cloudflare_video.twig)
      // so it's visible immediately with no JS dependency. Keep that fallback in sync.
      if (media.tagName === 'VIDEO-JS') {
        media.style.backgroundImage = `url('${media.dataset.posterDesktop}')`;
      }
    }
  });
}

heroDesktopMq.addEventListener('change', swapHeroPosters);
swapHeroPosters(heroDesktopMq);

// Hide the LCP poster fallback once the NATIVE hero video is actually playing
// (the cloudflare path handles this in cloudflare-video.js via the video.js
// player). The video may already be playing before this (interaction-delayed)
// script runs, hence the immediate check.
document.querySelectorAll('.hero-home video[data-hero-home-media-default]').forEach((video) => {
  const hero = video.closest('.hero-home');
  const poster = hero && hero.querySelector('.cloudflare-video__poster');
  if (!poster) return;

  const hidePoster = () => poster.classList.add('cloudflare-video__poster--hidden');

  if (!video.paused && video.currentTime > 0) {
    hidePoster();
  } else {
    video.addEventListener('playing', hidePoster, { once: true });
  }
});

// Start the NATIVE hero videos. They deliberately have no autoplay attribute —
// autoplay forces the browser to download every hero MP4 (~9MB each) during
// initial page load even with preload="none". This script is delayed by
// Perfmatters until first user interaction, so playback (and the download)
// begins only then; the poster <picture> covers the visuals until it does.
// initVideoControls also handles play() and the accessible pause button —
// its app.js auto-init only targets video[autoplay], so these are wired here.
const nativeHeroVideos = document.querySelectorAll(
  '.hero-home video[data-hero-home-media-default], .hero-home video[data-hero-home-nav-item]',
);
if (nativeHeroVideos.length) {
  initVideoControls(nativeHeroVideos);
}
